'use strict';

angular.module('ringbaPortal.services').factory('timeFormatService', timeFormatService);

function timeFormatService() {
  const service = {
    secondsToDisplay: secondsToDisplay,
    secondsToMinutesFormat: secondsToMinutesFormat
  };
  return service;

  function secondsToDisplay(sec, showTillMinutes) {
    sec = Math.round(sec);
    let hours;
    const timeUnitsArray = [];
    if (!showTillMinutes) {
      hours = Math.floor(sec / (3600));
      sec = sec - (hours * 3600);
      timeUnitsArray.push(hours);
    }
    const minutes = Math.floor(sec / (60));
    sec = sec - (minutes * 60);
    timeUnitsArray.push(minutes);
    const seconds = sec;
    timeUnitsArray.push(seconds);
    return timeUnitsArray.map(function (n) {
      if (n < 10) {
        return '0' + n;
      } else {
        return n;
      }
    }).join(':');
  }

  function secondsToMinutesFormat(sec) {
    const min = Math.floor(sec / 60);
    const remainingSeconds = sec - 60 * min;
    return min + ':' + (remainingSeconds < 10 ? '0' : '') + remainingSeconds;
  }


}
